<template>
  <div class="apps">
    <div class="bg-black p-2 rounded">
      <div class="">
        <div class="row">
            <div class="col-md-4">
              <div class="input-group flex-nowrap">
                <button class="btn btn-kraken fs-5 w-25 rounded">
                  <i class="fa-solid" :class="{'fa-refresh fa-spin':gettingApp,'fa-leaf': !gettingApp}"></i>
                </button>
                <input class="btn bg-black text-white fw-light fs-5 rounded" style="width: 100px; margin-top: -4px; cursor: default;" type="text" value="Apps" readonly>
                <select class="btn btn-kraken fs-5 fw-light rounded w-100" v-model="selected_app" @change="getStatus('Getting app data...')" :disabled="gettingApp">
                    <option :value="null">Select an app...</option>
                    <option v-if="false" value="alchemy">Alchemy</option>
                    <option value="panoptico">Panoptico</option>
                  </select>
              </div>
            </div>
            <div class="col-md-4"></div>
            <div class="col-md-4">
                <input class="btn bg-transparent text-white text-end fw-light fs-5 rounded w-100" style="cursor: default; letter-spacing: 3px; pointer-events: none;" type="text" :value="timestamp" readonly>
            </div>
        </div>
      </div>
    </div>
    <div class="bg-transparent p-2 rounded mt-2" style="height: 585px;">
        <!-- Neutral View. -->
        <div v-show="!appReady" class="fs-3 text-white">
            <div style="margin-top: 17%;">
                <i class="fa-solid fa-xl fa-leaf" :class="{'fa-beat': gettingApp}"></i>
                <p class="text-white fw-light">{{mainMessage}}</p>
            </div>
        </div>

        <!-- App View. -->
        <div v-if="appReady">
            <!-- Alchemy -->
            <div v-if="selected_app == 'alchemy'">
                <div class="row" style="margin-top: 6%;"  :class="{'disabled-div': app_data.name == null}">
                    <div class="col-2"></div>
                    <div class="col-4">
                        <div>
                            <div class="input-group flex-nowrap">
                                <input type="text" class="btn btn-suite fs-3 text-start w-100 me-1" :value="'App: ' + capitalize(selected_app)" readonly>
                                <button class="btn btn-suite fs-3 w-25" @click="getStatus('Getting app data...')">
                                    <i class="fa-solid fa-lg fa-refresh"></i>
                                </button>
                            </div>
                            <div class="border rounded border-dark">
                                <img :src="require(`@/assets/logos/${selected_app}_logo.png`)" :alt="capitalize(selected_app)" width="200" height="200" class="img-fluid rounded d-inline-block align-text-center mt-2">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div :class="{'disabled-div': app_data.status == 'stopped'}">
                            <input type="text" class="btn btn-suite fs-3 w-100" :value="'Status: ' + capitalize(app_data.status)" readonly>
                            <div class="input-group flex-nowrap border rounded border-dark">
                                <button class="btn w-100 border-top border-dark" style="height: 208px; font-size: 60px;" @click="setStatus('start')" :disabled="settingStatus || !app_data.paused">
                                    <i class="fa-solid fa-lg fa-play play-button"></i>
                                </button>
                                <button class="btn w-100 border-top border-dark" style="height: 208px; font-size: 60px;" @click="setStatus('pause')" :disabled="settingStatus || app_data.paused">
                                    <i class="fa-solid fa-lg fa-pause pause-button"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <input v-if="!settingStatus" class="btn w-100 fs-3" :class="{'btn-suite': app_data.run, 'btn-danger': !app_data.run}" type="text" :value="app_data.message + 'Hello'" readonly>
                        <div v-show="settingStatus">
                            <button class="btn w-100 fs-3" :class="{'btn-success': destatus=='start', 'btn-danger': destatus=='stop', 'btn-warning': destatus=='restart'}">
                                <i class="fa-solid fa-lg fa-leaf fa-beat me-2"></i>
                                {{app_data.message}}
                                <i class="fa-solid fa-lg fa-leaf fa-beat ms-2"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Panoptico -->
            <div v-if="selected_app == 'panoptico'">
                <div class="row" style="margin-top: 6%;"  :class="{'disabled-div': app_data.name == null}">
                    <div class="col-2"></div>
                    <div class="col-4">
                        <div>
                            <div class="input-group flex-nowrap">
                                <input type="text" class="btn btn-kraken fw-light fs-5 text-start w-100 me-1" style="letter-spacing: 3px; pointer-events: none;" :value="'App: ' + capitalize(selected_app)" readonly>
                                <button class="btn btn-kraken fs-5 w-25" @click="getStatus('Getting app data...')">
                                    <i class="fa-solid fa-refresh"></i>
                                </button>
                            </div>
                            <div class="bg-black border rounded border-dark">
                                <img :src="require(`@/assets/logos/${selected_app}_logo.png`)" :alt="capitalize(selected_app)" width="200" height="200" class="img-fluid rounded d-inline-block align-text-center mt-2">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div>
                            <input type="text" class="btn btn-kraken fs-5 fw-light w-100" style="letter-spacing: 3px; pointer-events: none;" :value="'Status: ' + capitalize(app_data.status)" readonly>
                            <div class="input-group flex-nowrap border rounded border-dark">
                                <button class="btn w-100 border-top border-dark" style="height: 208px; font-size: 60px;" @click="setStatus('start')" :disabled="settingStatus">
                                    <i class="fa-solid fa-lg fa-play play-button"></i>
                                </button>
                                <button class="btn w-100 border-top border-dark" style="height: 208px; font-size: 60px;" @click="setStatus('stop')" :disabled="settingStatus">
                                    <i class="fa-solid fa-lg fa-stop stop-button"></i>
                                </button>
                                <button class="btn w-100 border-top border-dark" style="height: 208px; font-size: 60px;" @click="setStatus('restart')" :disabled="settingStatus">
                                    <i class="fa-solid fa-lg fa-refresh restart-button"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <input v-if="!settingStatus" class="btn w-100 fs-5" :class="{'btn-kraken': app_data.run, 'btn-danger': !app_data.run}" style="pointer-events: none;" type="text" :value="app_data.message" readonly>
                        <div v-show="settingStatus">
                            <button class="btn w-100 fs-5" :class="{'btn-success': destatus=='start', 'btn-danger': destatus=='stop', 'btn-warning': destatus=='restart'}">
                                <i class="fa-solid fa-lg fa-leaf fa-beat me-2"></i>
                                {{app_data.message}}
                                <i class="fa-solid fa-lg fa-leaf fa-beat ms-2"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
  </div>
</template>

<script>
// Import the component with the line below.
//import Base from '@/components/Base.vue'

// Add this to parent headerbar: @setAppSection="setAppSection($event)"

import axios from "axios";

export default {
  name: 'Apps',
  components: {},
  data(){
    return {
      // General
      appclient: null,
      site: null,
      stage: null,
      mainMessage: "Select an app to manage.",
      // Base
        dappd: {name: null, run: false, message: null, status: 'status', timestamp: null}, 
        app_data: {name: null, run: false,  message: null, status: 'status', timestamp: null},
        selected_app: null,
        gettingApp: false,
        appReady: false,
        timestamp: null,
      // Status setting.
        destatus: null, // Desired status
        settingStatus: false,
        statesmsgs: { start: 'Starting app.', stop: 'Stopping app', restart: 'Restarting app.' }

    }
  },
  methods:{
    getStatus(message="Getting app data..."){
        this.app_data = this.dappd
        if (this.selected_app == null){
            this.clean()
            return
        }
        this.appReady = false
        this.gettingApp = true
        this.mainMessage = message
        // Send the request.
        const params = { appname: this.selected_app }
        const dest = this.site + `/suite/apps/getAppStatus`
        axios
            .get(dest, { params })
            .then(rx => {
                // OK
                this.app_data = rx.data.data
                this.app_data.name = this.app_data.name.toLowerCase()
                this.appReady = true
                this.gettingApp = false
                this.timestamp = this.app_data.timestamp
            })
            .catch(error => {
                var err_message = this.processErrorMessage(error)
                this.appReady = false
                this.gettingApp = false

        });

    },
    setStatus(_status){
        this.destatus = _status
        this.settingStatus = true
        this.app_data.status = 'Processing status...'
        this.app_data.message = 'Processing request...'
        // Send the request.
        const params = { action: this.destatus, appname: this.selected_app }
        const dest = this.site + `/suite/apps/setAppStatus`
        axios
            .post(dest, params)
            .then(rx => {
                // OK
                this.getStatus('Updating...')
                this.settingStatus = false
            })
            .catch(error => {
                this.appReady = true
                this.getStatus('Updating...')
                this.app_data.message = this.processErrorMessage(error)
                this.settingStatus = false
        });
    },
    clean(){
        this.app_data = this.dappd
        this.appReady = false
        this.gettingApp = false
        this.mainMessage = "Select an app to manage."
        // Setting status
        this.destatus = null
        this.settingStatus = false
    },
    toggleAppValue(keyname){
        alert(this.app_data[keyname])
    },
    // Errors
    processErrorMessage(error, mode="alert"){
        var err_message = null
        try {
            err_message = error.response.data.data.errorMessage
        } 
        catch (nerror) {
            try { 
                err_message = error.response.data.errorMessage
            } 
            catch (error) { 
                console.log(error) 
            }
        }
        if (mode == "alert"){ alert(err_message)  }
        else if (mode == "console"){ console.log(err_message)  }
    return err_message
    },

    // -- Miscellaneous
    capitalize(_string){
        if (_string == null){return ""}
        const lower = String(_string).toLowerCase()
        return String(_string).charAt(0).toUpperCase() + lower.slice(1)
    },
    printObject(_object){
        console.log(JSON.stringify(_object, null, "   "))
    },
    cloneObject(_object){
      return JSON.parse(JSON.stringify(_object))
    },
    getCookie(name){
        const cookies = document.cookie.split(';');
        for (let cookie of cookies) {
                cookie = cookie.trim();
                if (cookie.startsWith(name + '=')) {
                return cookie.substring(name.length + 1);
                }
        }
        return null;
    }
  },
  created: function(){
    //this.appclient = localStorage.getItem('vrfaware_client')
    //this.site = this.site.replace('_CLIENT_NAME_', this.appclient)
    this.stage = process.env.NODE_ENV
    if (this.stage == 'development'){
      this.site = process.env.VUE_APP_SERVICE_URL
    }
    else{
      this.site = `${window.location.protocol}//${window.location.host}/kraken`
    }
    axios.defaults.headers.common['X-CSRFToken'] = this.getCookie('csrf_prt')
  }
}
</script>

<style scoped>

  .border-suite{
    border-top: solid 2px rgb(0, 48, 90);
    border-bottom: solid 2px rgb(0, 48, 90);
    border-left: solid 2px rgb(0, 48, 90);
    border-right: solid 2px rgb(0, 48, 90);
  }

  .border-bottom-suite{
    border-bottom: solid 2px rgb(0, 48, 90);
  }

  .bg-suite{
    color: White;
    background-color: rgb(0, 48, 90);
    text-shadow: 3px 5px 4px Black;
  }

  .btn-suite{
    color: White;
    background-color: rgb(0, 48, 90);
    transition-duration: 0.5s;
    text-shadow: 3px 5px 4px Black;
    border-left: solid 6px transparent;
    border-right: solid 6px transparent;
  }
  .btn-suite:hover{
    color: rgb(0, 179, 255);
    background-color: rgb(1, 77, 144);
  }

    .disabled-div{
        pointer-events: none;
        opacity: 0.5;
    }

    .play-button{
        color: rgb(68, 163, 101);
        transition-duration: 0.5s;
    }
    .play-button:hover{
        color: rgb(20, 63, 162);
    }
    
    .pause-button{
        color: rgb(3, 127, 161);
        transition-duration: 0.5s;
    }
    .pause-button:hover{
        color: rgb(20, 63, 162);
    }

    .stop-button{
        color: rgb(224, 45, 54);
        transition-duration: 0.5s;
    }
    .stop-button:hover{
        color: rgb(20, 63, 162);
    }

    .restart-button{
        color: rgb(204, 247, 34);
        transition-duration: 0.5s;
    }
    .restart-button:hover{
        color: rgb(20, 63, 162);
    }


    .bg-input{
        background-color: rgb(7,13,15);
        color: white;
    }

    .temporal-disable{
        opacity: 0.5;
        pointer-events: none;
    }

    .btn-kraken{
        background-color: rgb(20, 63, 162);
        color: white;
        transition-duration: 0.5s;
    }
    .btn-kraken:hover{
        background-color: rgb(0, 17, 39);
        color: rgb(0, 211, 249);
    }

</style>
